import { ArrowUpRight } from "lucide-react";
import { splitOrder } from "../../lib/chat";
import { useLang } from "../../lib/i18n";

export const ChatBubble = ({ role, content, onDraft, index }) => {
  const { t } = useLang();
  const { clean, draft } = role === "assistant" ? splitOrder(content) : { clean: content, draft: null };
  const mine = role === "user";
  return (
    <div className={`flex ${mine ? "justify-end" : "justify-start"}`}>
      <div
        data-testid={`chat-msg-${role}-${index}`}
        className={`max-w-[85%] rounded-2xl px-4 py-3 text-sm leading-relaxed whitespace-pre-wrap ${mine ? "bg-[var(--husk)] text-[var(--forest)] rounded-br-md" : "bg-white/5 text-[var(--cream)] rounded-bl-md"}`}
      >
        {clean || <span className="inline-flex gap-1"><span className="h-1.5 w-1.5 rounded-full bg-[var(--sage)] animate-bounce" /><span className="h-1.5 w-1.5 rounded-full bg-[var(--sage)] animate-bounce [animation-delay:120ms]" /><span className="h-1.5 w-1.5 rounded-full bg-[var(--sage)] animate-bounce [animation-delay:240ms]" /></span>}
        {draft && (
          <button
            data-testid={`chat-review-order-btn-${index}`}
            onClick={() => onDraft(draft)}
            className="mt-3 flex w-full items-center justify-between gap-2 rounded-xl bg-[var(--cream)] text-[var(--forest)] px-3 py-2.5 font-semibold"
          >
            {t("chat.review")} · {draft.quantity_t || "?"} t
            <ArrowUpRight className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
};
